"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBootstrap = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var useBootstrap = function () {
    (0, swr_hooks_1.usePayInMethodsProfile)();
};
exports.useBootstrap = useBootstrap;
